"use client";
import { useState, useEffect, useRef } from "react";
import Image from "next/image";
import "photoswipe/dist/photoswipe.css";
import { Gallery, Item } from "react-photoswipe-gallery";
import { useParams } from "next/navigation";
import HeaderInner from "@/components/HeaderInner";
import * as ReactDOM from "react-dom";
import { getUserInfo } from "../../../../utilities/userInfo";
import FilterBar from "@/app/cin_booking_engine/Filterbar";
import { BookingEngineProvider } from "@/app/cin_context/BookingEngineContext";
import TigerLoader from "@/components/TigerLoader";

export default function PropertyGallery() {
  const [galleryData, setGalleryData] = useState([]);
  const [propertyId, setPropertyId] = useState(null);
  const [propertyData, setPropertyData] = useState([])
  const [activeCategory, setActiveCategory] = useState("all");
  const { propertySlug } = useParams();
  const [isMobile, setIsMobile] = useState(false);
  const [isOpen, setOpen] = useState(false);
  const [showFilterBar, setShowFilterBar] = useState(false);
  const filterBarRef = useRef(null);
  const [staahPropertyId, setStaahPropertyId] = useState(null);
  const [cityDetails, setCityDetails] = useState(null);
  const [brandId, setBrandId] = useState(null);
  const [isPageLoading, setIsPageLoading] = useState(true);
  const [brandData, setBrandData] = useState([]);

    const brandColors = {
    1: "#bf1e2d",
    4: "#bf1e2d",
    2: "#263997",
    3: "#f04e02",
    5: "#febb19",
    6: "#f9e12e",
  };

  const backgroundColor = brandColors[brandId] || "#f26624";

  useEffect(() => {
    typeof window !== "undefined" && window.scrollTo(0, 0);
    const storedBrandId = localStorage.getItem('brandId');
    setBrandId(storedBrandId);
  }, []);

  useEffect(() => {
    // Function to check if screen width is mobile
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 640); // 640px breakpoint
    };

    checkMobile(); // Initial check

    window.addEventListener("resize", checkMobile); // Update on resize

    return () => {
      window.removeEventListener("resize", checkMobile); // Clean up listener
    };
  }, []);

  useEffect(() => {
    if (!propertySlug) return;

    const fetchPropertyIdFromSlug = async (slug) => {
      try {
        const res = await fetch(
          `${process.env.NEXT_PUBLIC_ORANGE_TIGER_BASE_URL}/Api/property/GetPropertyList`
        );
        const json = await res?.json();
        if (json.errorMessage !== "success") {
          console.error("Property list fetch error:", json);
          return null;
        }
        const found = json.data.find((p) => p.propertySlug === propertySlug);
        setPropertyData(found);
        setCityDetails({ label: found?.cityName, value: found?.cityId, property_Id: found?.staahPropertyId });
        setStaahPropertyId(found?.staahPropertyId);
        return found?.propertyId || null;
      } catch (error) {
        console.error("Error fetching property list:", error);
        return null;
      }
    };

    const loadPropertyId = async () => {
      const id = await fetchPropertyIdFromSlug(propertySlug);
      setPropertyId(id);
    };

    loadPropertyId();
  }, [propertySlug]);

  useEffect(() => {
    const fetchGallery = async () => {
      try {
        const res = await fetch(
          `${process.env.NEXT_PUBLIC_ORANGE_TIGER_BASE_URL}/Api/gallery/GetGalleryByProperty?propertyId=${propertyId}`,
          { cache: "no-store" }
        );
        const json = await res.json();
        if (json.errorMessage === "success" && Array.isArray(json.data)) {
          setGalleryData(json.data);

          // Extract unique categories + prepend ALL
          const mappedGalleryData = json.data.flatMap((item) =>
            (item.galleryImages || []).map((img) => ({
              id: img.galleryImageId,
              src: img.image,
              caption: img.caption || "",
              category: item.galleryCategory,
            }))
          );
          setGalleryData(mappedGalleryData);

          // Set activeCategory to 'all' on new data load
          setActiveCategory("all");
        } else {
          setGalleryData([]);
          //setCategories(["ALL"]);
        }
      } catch (err) {
        console.error("Gallery fetch error:", err);
        setGalleryData([]);
      } finally{
        setIsPageLoading(false)
      }
    };
    if (propertyId) fetchGallery();
  }, [propertyId]);

  // Fetch brand data
        useEffect(() => {
          (async () => {
            try {
              const res = await fetch(
                `${process.env.NEXT_PUBLIC_ORANGE_TIGER_BASE_URL}/Api/property/GetBrandList`
              );
              const json = await res.json();
              setBrandData(json.data || []);
            } catch (e) {
              console.error("Error fetching brands:", e);
            }
          })();
        }, []);

  // Get unique categories from galleryData
  const categories = ["all", ...Array.from(new Set(galleryData.map((img) => img.category)))];

  const filteredImages =
    activeCategory === "all"
      ? galleryData
      : galleryData.filter((img) => img.category === activeCategory);

  const handlePropertyBookNow = async () => {
      setOpen(!isOpen);
      setShowFilterBar(!showFilterBar);
      if (filterBarRef.current) {
      filterBarRef.current.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
      const firstInput = filterBarRef.current.querySelector(
        "input, select, button"
      );
      if (firstInput) firstInput.focus();
    }
  };

  async function postBookingWidged(rooms, mapping, isClose, ctaName, selectedPropertyId) {
    const resp = await getUserInfo();
    const sessionId = sessionStorage?.getItem("sessionId");
    const payload = {
      ctaName: ctaName,
      urls: window.location.href,
      cityId: "0",
      propertyId: selectedPropertyId?.toString() || "0",
      checkIn: "",
      checkOut: "",
      adults: "0",
      children: "0",
      rooms: "0",
      promoCode: "",
      ip: resp?.ip,
      sessionId: sessionId,
      deviceName: resp?.deviceInfo?.deviceName,
      deviceType: resp?.deviceInfo?.deviceOS == "Unknown" ? resp?.deviceInfo?.platform : resp?.deviceInfo?.deviceOS,
      roomsName: rooms?.RoomName,
      packageName: mapping?.MappingName,
      isCartOpen: mapping?.MappingName ? "Y" : "N",
      isCartEdit: "N",
      isCartClick: "N",
      isClose: isClose ? "Y" : "N",
    }
       const response = await fetch(
         `${process.env.NEXT_PUBLIC_CMS_BASE_URL}/Api/tracker/BookingWidged`,
         {
           method: "POST",
           headers: {
             "Content-Type": "application/json",
           },
           body: JSON.stringify( payload ),
         }
       );
       const res = await response?.json();
  }

  if (isPageLoading) {
    return (
      <TigerLoader />
    );
  }

  return (
    <>
    <main style={{overflowY: "auto"}}>
      <HeaderInner brandData={brandData} propertyData={propertyData} brandId={brandId} backgroundColor={backgroundColor} propertyId={propertyData?.propertyId} onClick={handlePropertyBookNow} />
      {/* <HotelBookingBanner /> */}
      <section ref={filterBarRef} className="position-relative">
             <section className="position-fixed start-0 w-100 bg-white shadow" ref={filterBarRef}>
          {showFilterBar && typeof window !== "undefined" && ReactDOM.createPortal(
            <section className="filter-bar-hotels-cin">
              <BookingEngineProvider>
                <FilterBar
                  selectedProperty={parseInt(staahPropertyId)}
                  cityDetails={cityDetails}
                  openBookingBar={showFilterBar}
                  onClose={(isReload) => {
                    setOpen(false);
                    setShowFilterBar(false);
                    if (isReload) {
                      window.location.reload();
                    }
                  }}
                   isCloseButtonShow="true"
                   backgroundColor={backgroundColor}
                />
              </BookingEngineProvider>
            </section>,
            document.body
          )}
        </section>
      </section>

      <div style={{ paddingTop: "80px" }}></div>
      <section className="bg-white py-12">
             <h1 className="!text-[23px] text-center fw-semibold mb-3" style={{ color: backgroundColor }}>GALLERY</h1>
         <div className="w-10 h-1 bg-orange-500 mx-auto mt-2 mb-4" style={{ background: backgroundColor }}></div>
        <div className="container mx-auto px-4">
          {/* Filter Menu */}
          <div className="w-full md:w-5/5 flex justify-start md:justify-center overflow-x-auto shadow gap-4 px-3 py-2 mb-4 md:mb-5 categories-scroll">
            {categories.map((cat) => (
              <button
                key={cat}
                onClick={() => setActiveCategory(cat)}
                className={`uppercase text-[14px] font-medium pb-2 ${activeCategory === cat
                  ? "text-orange-500 border-b-2 border-orange-500"
                  : "text-gray-700 hover:text-orange-500"
                  }`}
                style={{
                  color: activeCategory === cat ? backgroundColor : "black",
                  borderColor: activeCategory === cat ? backgroundColor : "black",
                }}
              >
                {cat.charAt(0).toUpperCase() + cat.slice(1)}
              </button>
            ))}
          </div>

          {/* Gallery Grid */}
          {/* PhotoSwipe Gallery */}
          <Gallery withCaption>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
              {filteredImages.map(({ id, src, caption }) => (
                <div key={id} className="relative overflow-hidden rounded shadow-md">
                  <Item original={src} thumbnail={src} width="1024" height={isMobile ? 750 : 550} caption={caption}>
                    {({ ref, open }) => (
                      <Image
                        ref={ref}
                        onClick={open}
                        src={src || "/no_image.jpg"}
                        alt={caption || "Gallery Image"}
                        width={600}
                        height={isMobile ? 700 : 500}
                        className="gallery-image rounded"
                        style={{
                          width: "100%",
                          height: "250px",
                          objectFit: "cover",
                          cursor: "pointer",
                          transition: "transform 0.3s ease",
                        }}
                      />

                    )}
                  </Item>
                </div>
              ))}
            </div>
          </Gallery>
        </div>
      </section>
      </main>
    </>
  );
}
